<template>
  <Listbox v-model="selected" as="div" @update:modelValue="onUpdate">
    <div class="relative mt-1">
      <ListboxButton class="listbox-button">
        <span class="flex items-center">
          <span class="ml-3 block truncate">
            Sortierung
          </span>
        </span>
        <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
          <ChevronDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions class="listbox-options">
          <ListboxOption as="template" v-for="option in options" :key="option.value" :value="option" v-slot="{ active, selected }">
            <li :class="[active ? 'text-white bg-teal-600' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9']">
              <div class="flex items-center">
                <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                  {{ option.label }}
                </span>
              </div>
              <span v-if="selected" :class="[active ? 'text-white' : 'text-teal-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const options_raw =
{
  advice: {value: 'advice', label: 'Empfohlen'},
  latest: {value: 'latest', label: 'Neueste zuerst'},
  money: {value: 'money', label: 'Geldeinsatz'},
  effort: {value: 'effort', label: 'Zeiteinsatz'},
};

const options_free =
[
  options_raw['latest'],
  options_raw['money'],
  options_raw['effort'],
];

const options_paid =
[
  options_raw['advice'],
  options_raw['latest'],
  options_raw['money'],
  options_raw['effort'],
];

const props = defineProps({'modelValue': String});
const emits = defineEmits(['update:modelValue']);

const store = useStore();
const context = computed(() => store.getters['context/context']);
const premium = computed(() => context.value.active);

const options = computed(() => premium.value ? options_paid : options_free);
const initial = computed(() => options_raw[props.modelValue]);
const selected = ref(initial.value);

const onUpdate = (selection) =>
{
  const event = 'update:modelValue';
  const value = selection.value;
  emits(event, value);
};
</script>

<style scoped>
.listbox-button
{
  @apply relative py-2 pl-3 pr-10 w-48;
  @apply rounded-md;
  @apply text-left text-white font-semibold shadow-sm sm:text-sm;
  @apply focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500;
  @apply cursor-default;
}

.listbox-options
{
  @apply absolute z-10 mt-1 max-h-60 w-full overflow-auto;
  @apply rounded-md bg-white py-1 text-base shadow-lg focus:outline-none sm:text-sm;
  @apply ring-1 ring-black ring-opacity-5;
}
</style>
